import React, { useState } from "react";
import PortableText from "./portableText";
import clientConfig from "../../client-config";
import VideoModal from "./videoModal";
import * as styles from './sellHero.module.css';

import { getGatsbyImageData } from "gatsby-source-sanity";
import { GatsbyImage } from "gatsby-plugin-image";
const maybeImage = illustration => {
  let img = null;
  if (illustration && illustration.image && illustration.image.asset && !illustration.disabled) {
    const imageData = getGatsbyImageData(
      illustration.image,
      { maxWidth: 960 },
      clientConfig.sanity
    );

    img = (
      <GatsbyImage
        image={imageData}
        alt={illustration.image.alt}
      />
    );
  }
  return img;
};

function SellHero(props) {

    const featuredimg = maybeImage(props.featuredImage);
    const sectionimg = maybeImage(props.sectionImage);

    const [videoModalOpen, setVideoModalOpen] = useState(false);
    const [videoSrc, setVideoSrc] = useState(props.videoLink);
    
    let openVideoModal = () => {
        setVideoSrc(props.videoLink);
        setVideoModalOpen(true);
    }

    let closeVideoModal = () => {
        setVideoModalOpen(false);
        setVideoSrc('');
    }

    return (
        <>
            <div className={styles.sectionSellHero}>

                <div className={styles.heroWrap}>
                    <div className={styles.heroContainer}>
                        <div className={styles.bgCircle}>
                            <img src={require('../images/hero_circle.png').default} alt="Download in Google Play" />
                        </div>
                        <div className={styles.featuredImageWrap}>
                            {featuredimg}
                        </div>
                        <div className={styles.heroContentWrap}>
                            <h1>
                                <PortableText blocks={props.heading} />
                            </h1>
                            <div className={styles.mobileImage}>
                                {featuredimg}
                            </div>
                            <div className={styles.contentWrap}>
                                <PortableText blocks={props.content} />
                            </div>
                            {
                                (props.hasSearchBar) ? 
                                    <div className={styles.tagSearchBar}>
                                        <i class="fas fa-search"></i>
                                        <input type="text" name="address_search" placeholder="Address" required />
                                        <a href="#" className={styles.addressSearchBtn}>
                                            <span class="inline-block align-middle">Search</span>
                                            <img class="inline-block align-middle" src={require('../images/arrow-right-white.png').default} alt="Right arrow" />
                                        </a>
                                    </div>
                                    : ``
                            }
                            <div className={styles.sectionCTAs}>
                                {
                                    (props.video_cta_label) ?
                                        <a href="#" className={styles.watchBtn} onClick={openVideoModal}>
                                            <span>{props.video_cta_label}</span>
                                            <img src={require('../images/play-icon.png').default} alt="Right arrow" />
                                        </a>
                                    : ``
                                }
                                <a href={props.cta_link} className={styles.desktopLink} target="_blank">
                                    <span>{props.cta_label}</span>
                                    <img src={require('../images/arrow-right.png').default} alt="Right arrow" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={styles.preSectionWrap}>
                    <div className={styles.sectionContainer}>
                        <div className={styles.sectionFirstCol}>
                            <div className={styles.imageWrapper}>{sectionimg}</div>
                        </div>
                        <div className={styles.sectionSecondCol}>
                            <div className={styles.sectionContent}>
                                <h3>{props.sectionTitle}</h3>
                                <PortableText blocks={props.sectionContent} />
                                <a href={props.sectionCtaLink} className={styles.sectionCta}>
                                    <span class="inline-block align-middle">{props.sectionCtaLabel}</span>
                                    <img class="inline-block align-middle" src={require('../images/arrow-right-white.png').default} alt="Right arrow" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <VideoModal videoSrc={videoSrc} isOpen={videoModalOpen} closeVideoModal={closeVideoModal} />
        </>
    );
}

export default SellHero;
